import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

export const RouterLink = forwardRef(function RouterLink(
  { to, children, ...props },
  ref,
) {
  if (to) {
    // If 'to' prop is provided, use Link from react-router-dom
    // Implement: <RouterLink to="/path">Link Text</RouterLink>
    return (
      <Link to={to} ref={ref} {...props}>
        {children}
      </Link>
    );
  } else {
    // If 'to' prop is not provided, use a regular anchor tag
    // Implement: <RouterLink href="/external-path">External Link Text</RouterLink>
    return (
      <a href={props.href} ref={ref} {...props}>
        {children}
      </a>
    );
  }
});
